import { useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { useSessionStore } from '../store/useSessionStore';
import { syncBranchSettingsFromLocalCacheToSession } from '../../../auth/infra/branches/branchSettingsSessionSync';

/**
 * Mantiene políticas POS de sucursal (stock, barcode, descuentos) alineadas con SQLite
 * al volver a una pantalla operativa tras editar Config. sucursal.
 */
export function useSyncBranchSettingsOnFocus(): void {
  const currentBranchId = useSessionStore((state) => state.currentBranchId);

  useFocusEffect(
    useCallback(() => {
      if (!currentBranchId) return;
      void syncBranchSettingsFromLocalCacheToSession();
    }, [currentBranchId])
  );
}
